import { SentifyStatus } from 'modules/ESGSentiment/types/esgSentiment';
import { fetchApi, getFetchApiJSONResponse, catchFetchApiError } from 'shared/functions';

export const fetchSentimentSummary = (id: string) =>
  fetchApi(`/sentifi/daily-score/${id}`).then(getFetchApiJSONResponse).catch(catchFetchApiError);

export const fetchSentimentAvailability = (id: string): Promise<SentifyStatus> =>
  fetchApi(`/sentifi/organization-company/${id}`)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const requestSentimentScore = (id: string): Promise<SentifyStatus> => {
  const formData = new FormData();
  formData.append('company_id', id);

  return fetchApi(
    '/sentifi/organization-company/',
    {
      method: 'POST',
      body: formData,
    },
    ['Content-Type'],
  )
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};
